import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cc3b1b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Usage-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-wrap text-truncate mb-3" }, [
  /*#__PURE__*/_createTextVNode("My Organization "),
  /*#__PURE__*/_createElementVNode("span", null, "» Reports")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrgUsageStatBarGraphs = _resolveComponent("OrgUsageStatBarGraphs")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.organizationId)
      ? (_openBlock(), _createBlock(_component_OrgUsageStatBarGraphs, {
          key: 0,
          organizationId: _ctx.organizationId,
          roomFilter: true,
          locationFilter: true,
          showExampleData: _ctx.showTierCallout
        }, null, 8, ["organizationId", "showExampleData"]))
      : _createCommentVNode("", true),
    _createVNode(_component_TierLimit, {
      modelValue: _ctx.showTierCallout,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showTierCallout) = $event)),
      isCallout: false,
      isLimit: false,
      message: "Upgrade your Ditto account to unlock reports."
    }, null, 8, ["modelValue"])
  ])), [
    [_directive_loading, _ctx.pageLoading]
  ])
}